import React, { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  Alert,
} from '@mui/material';

const MFAVerification = ({ onVerify, onCancel }) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!code) {
      setError('Bitte geben Sie den Verifizierungscode ein.');
      return;
    }
    onVerify(code);
  };

  return (
    <Box sx={{ maxWidth: 400, mx: 'auto', mt: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h5" gutterBottom>
          Zwei-Faktor-Authentifizierung
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Bitte geben Sie den Verifizierungscode aus Ihrer Authentifikator-App ein.
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <TextField
            label="Verifizierungscode"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            fullWidth
            margin="normal"
            autoFocus
          />
          <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
            >
              Verifizieren
            </Button>
            <Button
              variant="outlined"
              onClick={onCancel}
              fullWidth
            >
              Abbrechen
            </Button>
          </Box>
        </form>
      </Paper>
    </Box>
  );
};

export default MFAVerification; 